export default function Loading() {
  return (
    <div className="flex items-center justify-center bg-[#00000070] absolute top-0 left-0 right-0 bottom-0 text-2xl text-white z-50">
      Cargando...
    </div>
  );
}
